import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { ProductMigration } from '../migration-side-nav/product-migration';
import { MigrationDetailsService } from '../migration-details/migration-details.service';
import { PracticeCSMigration } from '../migration-products/practicecs-migration';
import { UltrataxCSMigration } from '../migration-products/ultrataxcs-migration';
import { BentoAlertItemOptions} from '@bento/bento-ng';
import { FileCabinetCS } from '../migration-products/file-cabinet-cs';
import { MigrationSource } from '../migration-reusable-components/migration-source.enum';
import { ParametrizedBentoSideNavItem } from '../migration-reusable-components/parametrized-bento-side-nav-Item';
import { LoadProduct } from '../migration-side-nav/load-product';
import { MigrationConstants } from '../migration-reusable-components/migration-constants';

@Component({
	selector: 'app-migration-container',
	templateUrl: './migration-container.component.html',
	styleUrls: ['./migration-container.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MigrationContainerComponent implements OnInit, OnDestroy {
	readonly PREPARE_FOR_MIGRATION_LINK = MigrationConstants.PREPARE_FOR_MIGRATION_LINK;
	alerts: BentoAlertItemOptions[] = [];
	/**
	 * Selected Product will be supplied from `MigrationSideNavComponent`
	 * Based on the product selected, new class will be instantiated or
	 * reused from `MigrationDetailsService`
	 */
	@Input() selectedProduct: ParametrizedBentoSideNavItem<LoadProduct>;
	productInfo: ProductMigration;
	migrationSource: MigrationSource;
	migrationInprogress = true;
	migrationCompleted = false;

	constructor(private migrationDetails: MigrationDetailsService) {
	}

	ngOnInit() {
		if (this.selectedProduct && this.selectedProduct.data) {
			this.migrationSource = this.selectedProduct.data.migrationSource;
		} else {
			this.migrationSource = undefined;
		}
		let activeProduct: ProductMigration;

		/**
		 * Based on the product selected, new class will be instantiated or
		 * reused from `MigrationDetailsService`
		 */
		if (!this.migrationDetails.productMigrationStateMap.has(this.migrationSource)) {
			switch (this.migrationSource) {
			case MigrationSource.PRACTICECS:
				activeProduct = new PracticeCSMigration();
				break;
			case MigrationSource.ULTRATAX:
				activeProduct = new UltrataxCSMigration();
				break;
			case MigrationSource.FILECABINET:
				activeProduct = new FileCabinetCS();
				break;
			}
			this.migrationDetails.productMigrationStateMap[this.migrationSource] = activeProduct;
		} else {
			activeProduct = this.migrationDetails.productMigrationStateMap.get(this.migrationSource);
		}

		this.productInfo = activeProduct;
	}

	ngOnDestroy() {
		// set back the updated state to the service
		this.migrationDetails.productMigrationStateMap.set(this.migrationSource, this.productInfo);
	}
}
